module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('a', {
    attrs: {
      "id": "title4"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("All references are from The National Archives (formerly Public Record Office, Kew):")])]), _vm._v(" "), _c('p', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("HO 45/9315/15372, Lydia Venables; HO 144/235/A51321, Thomas Neal; CRIM 1/43/10, Alfred Chipperfield; HO 144/266/A57652, Alfred Chipperfield; CRIM 1/84, George Chapman; CRIM 1/97/4, Albert Bridgeman; CRIM 1/108/4, Walter Fensham; HO 144/15375, Walter Fensham; PCOM 9/734, Walter Fensham; CRIM 1/293, Arthur Robert Canham; HO 144/20627, Arthur Robert Canham; MEPO 3/1608, Arthur Robert Canham; CRIM 1/940, Frederick Murphy; DPP 2/463, Frederick Murphy; HO 144/20658, Frederick Murphy; HO 144/20659, Frederick Murphy; MEPO 3/874, Frederick Murphy; MEPO 3/1647, Frederick Murphy; CRIM 1/1831, Harry Morley; HO 45/22559, Harry Morley; CRIM 1/2577, Nicky Xinaris; PCOM 9/2201, Nicky Xinaris; CRIM 1/3147, Ronald Henry Marwood; HO 291/242, Ronald Henry Marwood; HO 291/243, Ronald Henry Marwood; PCOM 9/2095, Ronald Henry Marwood; CRIM 1/3946, John Patrick Quinlan")])])])]), _c('a', {
    attrs: {
      "id": "title4"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2af8a988","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781783469529_fm03.vue
// module id = 75
// module chunks = 0